<template>
    <tbody class="body-wrapper">
        <Row v-for="row in rows" :key="row.rowId" :row="row" @colClick="clickHandler" />
        <tr v-if="!rows || rows.length === 0">
            <td :colspan="colNum" class="table-no-data">{{ $t("zhiji.common.noData") }}</td>
        </tr>
    </tbody>
</template>

<script>
import Row from "./Row";

export default {
    name: "Body",
    components: {
        Row
    },
    props: ["rows", "colNum"],
    methods: {
        clickHandler(data) {
            this.$emit("colClick", data);
        }
    }
};
</script>

<style lang="less" scoped>
.body-wrapper {
    .table-no-data {
        text-align: center;
        padding: 21px 0 22px 20px;
        color: #9b9ba3;
    }
}
</style>
